import { render, staticRenderFns } from "./additionalInfo.vue?vue&type=template&id=ed96ccf2&scoped=true"
import script from "./additionalInfo.vue?vue&type=script&lang=js"
export * from "./additionalInfo.vue?vue&type=script&lang=js"
import style0 from "./additionalInfo.vue?vue&type=style&index=0&id=ed96ccf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed96ccf2",
  null
  
)

export default component.exports